import { render, staticRenderFns } from "./CustomVideoControls.vue?vue&type=template&id=5ee4016a&scoped=true&"
import script from "./CustomVideoControls.vue?vue&type=script&lang=js&"
export * from "./CustomVideoControls.vue?vue&type=script&lang=js&"
import style0 from "./CustomVideoControls.vue?vue&type=style&index=0&id=5ee4016a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee4016a",
  null
  
)

export default component.exports